import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Skills from './components/Skills';
import ITProjects from './components/ITProjects';
import UXProjects from './components/UXProjects';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="min-h-screen bg-[#0062AD] text-[#FBF0DC]">
      <Navigation />
      <main>
        <div className="mx-auto max-w-[1200px] px-[clamp(20px,5vw,72px)]">
          <Hero />
          <Skills />
          <ITProjects />
          <UXProjects />
        </div>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
